<template>
  <div>
    <b-card class="standardpage reports border-none px-0 mx-0">
      <b-card-header class="px-0 mx-0">
        <b-row>
          <b-col cols="12" class="text-right text-sm-left pt-1">
            <i :class="ticketsinvalid.icon" class="mr-1"></i>
            <span>{{ ticketsinvalid.title }} </span>
          </b-col>
        </b-row>

        <b-tooltip target="refresh" triggers="hover"
          >Click to refresh</b-tooltip
        >
      </b-card-header>

      <div v-if="!component" class="availtable datatable small">
        <!-- <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Date Order"
                  label-size="sm"
                >
                  <b-input-group>
                    <daterangepicker
                      size="sm"
                      ref="dateplaced"
                      v-model="dateplaced_at"
                      :opens="'right'"
                      :locale-data="locale_data"
                      :ranges="locale_ranges"
                      :linkedCalendars="true"
                    >
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="
                          dateplaced = {
                            startDate: null,
                            endDate: null,
                          }
                        "
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Your Ref / PO"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="yourref"
                      :debounce="ticketsinvalid.debounce"
                      placeholder="Your Ref"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!yourref"
                        @click="yourref = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Client SL A/C"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select slac..."
                    searchPromptText="Type at least 3 chars..."
                    v-model="slac"
                    :multiple="true"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadSLAC"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="readonly"
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect
                    placeholder="Select status..."
                    v-model="status"
                    :clearable="true"
                    :options="status_options"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="readonly"
                  >
             
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect
                    placeholder="Select event..."
                    searchPromptText="Type at least 4 chars..."
                    v-model="eventcode"
                    :multiple="true"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadEvent"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="agent"
                      :debounce="ticketsinvalid.debounce"
                      placeholder="Agent"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!agent"
                        @click="agent = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card> -->
        <div class="px-0 mx-0">
          <d-table
            classdivtable="availtable datatable"
            refid="ticketsinvalid"
            :icon="ticketsinvalid.icon"
            :toolbar="ticketsinvalid.toolbar"
            :toolbarlibrary="ticketsinvalid.toolbarlibrary"
            :toolbarinit="ticketsinvalid.toolbarinit"
            :badges="ticketsinvalid.badges"
            :fields="ticketsinvalid.fields"
            :items="ticketsinvalid.items"
            :busy="ticketsinvalid.busy"
            :page="ticketsinvalid.page"
            :showpages="false"
            @toolbar="ticketsinvalid_toolbar"
            @click="ticketsinvalid_click"
            @select="ticketsinvalid_select"
            @load="load"
          >
          </d-table>
        </div>
      </div>
      <!-- <div v-if="component">
        <component
          :is="component"
          :selection="selected"
          :config="cconfig"
          @discard="ticketsinvalid_click('discard')"
          @refresh="ticketsinvalid_click('refresh')"
        ></component>
      </div> -->
    </b-card>
    <!-- <Sidebardocuments
      :search="search"
      @discard="discard(row)"
      @refresh="refresh()"
    /> -->
  </div>
</template>
<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "TicketsInvalid",

  mounted() {
    this.load();
  },
  data() {
    return {
      busy: false,
      id: null,
  
      ticketsinvalid: {
        title: "Invalid Tickets",
        icon: "fa fa-ticket",
        debounce: 500,
        busy: false,
        page: 1,
        toolbar: [],
        toolbarlibrary: [  ],
        toolbarinit:"",

        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px text-danger",
          },
          {
            key: "ticketno",
            label: "Ticket No",
            sortable: true,
            class: "",
          },
           {
            key: "passenger",
            label: "Passenger",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (value.length >= 20) {
                result = value.slice(0, 17) + " ...";
              }
              return result;
            },
          },
        
        
          {
            key: "fare",
            label: "Fare",
            sortable: true,
            class: "text-right",
          },
          {
            key: "tax",
            label: "Tax",
            sortable: true,
            class: "text-right",
          },       
        
          
        ],
        badges: [],
        items: [],
        selected: [],
      },
    };
  },
  watch: {
    // async dateplaced_at() {
    //   await this.load();
    // },
    // async yourref() {
    //   this.dateplaced_at.startDate = null;
    //   this.dateplaced_at.endDate = null;
    //   this.agent = null;
    //   await this.load();
    // },
    // async slac() {
    //   await this.load();
    // },
    // async eventcode() {
    //   await this.load();
    // },
    // async agent() {
    //   await this.load();
    // },
    // async status() {
    //   await this.load();
    // },
  },

//   computed: {
//     readonly() {
//       return this.user.rolename == "client";
//     },
//   },

  methods: {
    async load(offset, limit) {
      if (!offset) {
        this.currentpage = 1;
        offset = 0;
      }

      this.ticketsinvalid.items = [];

      console.log("load()");
      // NO WILDCARD SEARCHES
      if (
        !this.dateplaced_at.startDate &&
        !this.dateplaced_at.endDate &&
        !this.yourref &&
        !this.slac &&
        !this.eventcode &&
        !this.status &&
        !this.agent
      ) {
        return;
      }

      this.ticketsinvalid.busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        dateplaced_at: [
          this.dateplaced_at.startDate,
          this.dateplaced_at.endDate,
        ],
        //eventcode: this.eventcode,
        agent: this.agent,
        yourref: this.yourref,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        //slac: this.slac,
        status: this.status,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            # query orders(
            query orders(
              $limit: Int
              $offset: Int
              $id: String
              $dateplaced_at: [String]
              $slac: String
              $yourref: String
              $eventcode: String
              $agent: String
              $status: String
              $dateformat: String
            ) {
              orders(
                limit: $limit
                offset: $offset
                id: $id
                dateplaced_at: $dateplaced_at
                yourref: $yourref
                slac: $slac
                eventcode: $eventcode
                agent: $agent
                status: $status
                dateformat: $dateformat
              ) {
                id
                yourref
                slac
                reason
                dateplaced
                eventcode
                eventname
                value
                spent
                credit
                remaining
                forecast
                forecast_on #needed for donuts
                notes
                status
                attachment
                agent
                rows
              }
            }
          `,
          variables,
        });

        if (limit > this.limit) {
          return response.data.orders;
        }

        this.ticketsinvalid.items = response.data.orders;

        if (response.data.orders.length > 0) {
          this.rows = response.data.orders[0].rows;
        }

        for (var k = 0; k < this.ticketsinvalid.items.length; k++) {
          if (
            this.ticketsinvalid.items[k].value &&
            this.ticketsinvalid.items[k].spent
          ) {
            this.ticketsinvalid.items[k].progress = (
              (this.ticketsinvalid.items[k].spent /
                this.ticketsinvalid.items[k].value) *
              100
            ).toFixed(2);
          }
        }
      } catch (error) {
        console.log(error);
      }

      this.ticketsinvalid.busy = false;
    },
    ticketsinvalid_toolbar(s) {
      console.log("ticketsinvalid_toolbar", s);
      if (this.ticketsinvalid.toolbar) {
        let toolbar = this.ticketsinvalid.toolbar;
        console.log(toolbar.length);
        for (var j = 0; j < toolbar.length; j++) {
          let tool = toolbar[j];
          switch (tool.action) {
            case "filter":
            case "add":
            case "export":
            case "refresh":
              tool.disabled = false;
              break;
            case "deleteconfirm":
              tool.disabled = s.length >= 1 ? false : true;
              break;
            case "edit":
              tool.disabled = s.length == 1 ? false : true;
              break;
            case "invoices":
              tool.disabled = s.length == 1 ? false : true;
              break;

            case "chart":
              tool.disabled = s.length == 1 ? false : true;
              break;
            case "outlook":
              tool.disabled = s.length == 1 ? false : true;
              break;

            default:
              tool.disabled = true;
          }
        }
      }
    },
    // async ticketsinvalid_click(a, s) {
    //   // console.log("ticketsinvalid_click", a, s);

    //   // IMPORTANT TO CHILD COMMS
    //   //  this.cconfig.eventcode = this.eventcode;
    //   this.selected = s;

    //   switch (a) {
    //     case "filter":
    //       this.showfilter = !this.showfilter;
    //       break;
    //     case "discard":
    //     case "refresh":
    //       this.component = null;
    //       //   this.dateSelector();
    //       this.load();
    //       break;
    //     case "add":
    //       this.component = "OrdersEdit";
    //       break;
    //     case "edit":
    //       this.component = "OrdersEdit";
    //       break;

    //     case "notes":
    //       this.component = "OrdersNotes";
    //       break;
    //     case "invoices":
    //       this.component = "OrdersInvoices";
    //       break;
    //     case "chart":
    //       this.component = "OrdersChart";
    //       break;
    //     case "delete":
    //       this.deleteit(s);
    //       break;
    //   }
    // },
    // _toolDisabled(a) {
    //   // console.log("local toolDisabled: ", a);
    //   switch (a) {
    //     case "notes":
    //       return this.orders.selected.length == 1 ? false : true;
    //     case "invoices":
    //       return this.orders.selected.length == 1 ? false : true;
    //     case "chart":
    //       return this.orders.selected.length > 0 ? false : true;
    //   }
    // },

    ticketsinvalid_select(s) {
      console.log("ticketsinvalid_select", s);
      this.ticketsinvalid.selected = s;
    },

    // async deleteit(s) {

    //   let rows = [];
    //   s.forEach(function (v) {
    //     rows.push({ id: v.id });
    //   });

    //   let variables = {
    //     rows,
    //   };

    //   try {
    //     const response = await this.$apollo.mutate({
    //       mutation: gql`
    //         mutation deleteorders($rows: [Order_input]) {
    //           deleteorders(rows: $rows) {
    //             id
    //           }
    //         }
    //       `,
    //       variables,
    //     });
    //   } catch (error) {
    //   }

    //   await this.load();
    // },
  },
};
</script>

<style>
</style>